module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-11a8b6c1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/body/payment/paypal/standard/Start.vue
// module id = 230
// module chunks = 1